// COMPONENTS
import fields_table_list from './custom-fields/fields-table-list.js';
import field_list from './custom-fields/field-list.js';
import map_definition_list from './json_mapper/map-definition-list.js';
import map_field_list from './json_mapper/map-field-list.js';
import lookup_list from './lookup/lookup-list.js';
import lookup_value_list from './lookup/lookup-value-list.js';
import ko_field_table_builder from './ko-field-table-builder/ko-field-table-builder.js';
import profile_user_details_tab from './profile-tabs/user-details.js';
import profile_access_roles_tab from './profile-tabs/access-roles.js';
import profile_authentication_tab from './profile-tabs/authentication.js';
import profile_sessions_tab from './profile-tabs/sessions.js';
import profile_overview_tab from './profile-tabs/overview.js';
import profile_api_keys_tab from './profile-tabs/api-keys.js';
import json_mapper_editor from './json_mapper_editor/json-mapper-editor.js';

export default [
	fields_table_list,
	field_list,
	map_definition_list,
	map_field_list,
	lookup_list,
	lookup_value_list,
	ko_field_table_builder,
	profile_overview_tab,
	profile_user_details_tab,
	profile_access_roles_tab,
	profile_authentication_tab,
	profile_sessions_tab,
	profile_api_keys_tab,
	json_mapper_editor
];
